import React, {useEffect} from 'react';

import {Route, Routes, useParams} from "react-router-dom";
import {useLocation, useNavigate} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {useGetGuidMapQuery} from "../../core/api/bermuda-charge-api";
import UserStates from "../UserStates";
import Charger from "../Charger/ba";
import AllBaChargerLogs from "../ChargerLogs/ba/AllBaChargerLogs";
import PrefabsBa from "../Prefabs/ba/PrefabsBa";
import WhiteListManagement from "../WhiteListManagement";
import {Box, Divider, MenuList, Stack, Toolbar} from "@mui/material";
import CollapsibleDrawer from "../../components/Common/Layout/CollapsibleDrawer";
import NavMenuItem from "../../components/Common/Layout/NavMenuItem";
import {useMenu} from "../../core/context/menuContext";
import AiTicketsDrawer from "../../components/AiTickets/AiTicketsDrawer";
import SearchBar from "../Search";
import Loading from "../../components/Common/Loading";
import DashboardBA from "../Dashboard/ba";
import UserStatesBA from "../UserStates/ba";
import ChargeManagement from "../ChargeManagement/ba";
import ArchiveRT from "../Archive/rt/ArchiveRT";
import ArchiveBA from "../Archive/ba/ArchiveBA";
import SearchBarBA from "../Search/SearchBA";
import AdvancedSearchCM from "../AdvancedSearch/AdvancedSearchCM";
import AdvancedSearchBA from "../AdvancedSearch/AdvancedSearchBA";
import PersonalData from "../PersonalData";
import AiZendeskSettings from "../AiZendesk";

export default function MainBA() {
    const {game, action} = useParams();

    const CommonData = useSelector((state) => state.data.CommonData)
    const mode = useSelector((state) => state.data.SourceMode)
    const deviceId = CommonData.deviceId ? CommonData.deviceId : '';
    const stateId = CommonData.stateId ? CommonData.stateId : '';

    // expanded/collapsed by the burger button in the Header
    const {open: menuOpen} = useMenu()

    const main_menu = [
        {
            to: '/' + game + '/dashboard/' + deviceId,
            path: 'dashboard/:deviceId?',
            title: 'Dashboard',
            element: <DashboardBA/>
        },
    ];
    const state_menu = [
        {
            to: '/' + game + '/state/' + deviceId + '/' + stateId,
            path: 'state/:deviceId?/:tab?',
            title: 'UserStates',
            element: <UserStatesBA/>,
            // disabled: deviceId == ''
        },
        {to: '/' + game + '/charger/' + deviceId + '/' + stateId, path: 'charger/:deviceId?', title: 'Charger', element: <Charger/>},

        {to: '/' + game + '/logs', path: 'logs', title: 'ChargerLogs', element: <AllBaChargerLogs/>},
        //{to:'reports', title:'Reports',component:'<Reports />'},

    ]
    const common_menu = [
        {
            to: '/' + game + '/prefabs/' + deviceId + '/' + stateId,
            path: "prefabs/:deviceId?",
            title: 'Prefabs',
            element: <PrefabsBa game={game}/>
        },
        {
            to: '/' + game + '/archive/' + deviceId,
            path: "archive/:deviceId?",
            title: 'Archive',
            element: <ArchiveBA game={game}/>
        },
        {
            to: '/' + game + '/search',
            path: "search",
            title: 'Search',
            element: <AdvancedSearchBA game={game}/>
        }
    ]
    const admin_menu = [
        {
            to: '/' + game + '/chargeManagement',
            path: "chargeManagement",
            title: 'Charge Management',
            element: <ChargeManagement game={game}/>
        },
        {
            to: '/' + game + '/whitelistManagement',
            path: "whitelistManagement",
            title: 'White list management',
            element: <WhiteListManagement/>
        },
        ...(mode.isProd ? [{
            to: `/${game}/personal-data`,
            path: "personal-data",
            title: "GDPR",
            element: <PersonalData initialProject="bermuda" />
        }] : []),
        ...(mode.isProd ? [{
            to: `/${game}/ai-zendesk`,
            path: "ai-zendesk",
            title: "Zendesk",
            element: <AiZendeskSettings game={game} />
        }] : [])
    ]

    // first path segment ("dashboard/:deviceId?" -> "dashboard") matches the :action route param
    const isActive = (object) => object.path.split("/")[0] === action

    let menu = [
        ...main_menu,
        ...state_menu,
        ...common_menu
    ]


    const routes = (
        <Route>

            {menu.map((object) => (
                <Route path={object.path} element={object.element}/>
            ))}
            {admin_menu.map((object) => (
                <Route path={object.path} element={object.element}/>
            ))}
        </Route>
    );


    // Stack, not Box: App.css has a global ".MuiBox-root a" rule that would break the vertical menu
    return (
        <Stack direction="row" className="wrapper" sx={{flexGrow: 1, minWidth: 0, width: "100%"}}>
            <CollapsibleDrawer anchor="left" width={230} open={menuOpen} label="menu" hideScrollbar>
                <MenuList>
                    {menu.map((object) => (
                        <React.Fragment key={object.path}>
                            <NavMenuItem {...object} open={menuOpen} selected={isActive(object)}/>
                            {object?.isDividerAfter && <Divider/>}
                        </React.Fragment>
                    ))}
                    <Divider/>

                    {admin_menu.map((object) => (
                        <NavMenuItem key={object.path} {...object} open={menuOpen} selected={isActive(object)}/>
                    ))}
                </MenuList>
            </CollapsibleDrawer>
                <Box component="main"
                     sx={{flexGrow: 1, minWidth: 0, p: 3}}
                >
                    <Toolbar/>

                    {['chargeManagement', 'whitelistManagement','search', 'personal-data', 'ai-zendesk'].indexOf(action) == -1 &&
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 2
                            }}>
                            <SearchBarBA/>
                        </Box>
                    }

                        <Box sx={{
                            width: "100%",
                            mb: 2
                        }}>
                            <Routes>
                                {routes}
                            </Routes>
                        </Box>
                </Box>
            <AiTicketsDrawer/>
        </Stack>
    );
}
